/**
 * Form keys
 */
export const AUTH_TYPE_FORM_KEY = 'authType'
export const NAME_FORM_KEY = 'name'
export const EMAIL_FORM_KEY = 'email'
export const USERNAME_FORM_KEY = 'usernameOrEmail'
export const PASSWORD_FORM_KEY = 'password'
export const PROVIDER_TYPE_FORM_KEY = 'provider'
export const REDIRECT_PATH_FORM_KEY = 'redirect'
export const INVITE_LINK_ID_FORM_KEY = 'invitationLinkId'
export const INVITE_TOKEN_FORM_KEY = 'invitationToken'
export const MEMBER_ID_FORM_KEY = 'memberId'
export const VERIFICATION_CODE_FORM_KEY = 'verificationCode'
export const CAPTCHA_TOKEN_FORM_KEY = 'captchaToken'
/**
 * Form values
 */
export const SSO_AUTH_TYPE = 'sso'
export const PLAIN_AUTH_TYPE = 'user-pass'

/**
 * Query Keys
 */
export const AUTO_LOGIN_FLAG_QUERY_KEY = 'auto_login'
